// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/* DISCLAIMER */\n\n#disclaimer {\n    width:100%;\n\tbackground-color:#5b5b5b;\n\tpadding:20px 20px 20px 20px;\n}\n\n   #disclaimer-content {\n\t   color:#FFF;\n   }\n\n/* FOOTER */\n\n#footer {\n    width:100%;\n\tbackground-color:#333333;\n\tpadding:20px 20px 20px 20px;\n}\n   \n   #footer-wrapper-copyright {\n\t   color:#FFF;\n   }", ""]);
// Exports
module.exports = exports;
